module.exports = __webpack_public_path__ + "img/debit-card.b31cb0e6.svg";